<template>
    <div>
        <h2 class="clearfix mb-4">
            {{ $t('edit-workflow') }}
            <div class="float-right">
                <button @click="saveWorkflow" class="btn btn-primary" :disabled="!workflow.title">{{ $t('save') }}</button>
                <StatusSelector :workflow="workflow" v-if="workflow.id"></StatusSelector>

            </div>
        </h2>

        <div v-if="saved">
            <div class="alert alert-success mt-8">{{ $t('saved') }}</div>
        </div>

        <div class="row mb-5">
            <div class="col-12 col-lg-4 mb-4 d-flex flex-column">
                <TextInput :label="$t('title')" v-model="workflow.title" />

                <TextAreaAutosize :label="$t('description')" v-model="workflow.note" />

                <div class="list-group border-radius-2 no-border my-3">
                    <div class="list-group-item">

                        <CheckboxInput v-model="workflow.visibleinnewmenu" :label="$t('visible-in-new-menu')"
                            class="mb-0" />

                        <TextInput v-if="workflow.visibleinnewmenu" :label="$t('new-menu-caption')"
                            v-model="workflow.newcaption" :placeholder="workflow.title" class="mt-3" />

                    </div>
                </div>

                <!--div class="list-group border-radius-2 no-border">
                    <div class="list-group-item">

                        <CheckboxInput v-model="workflow.visibleinsidebar" :label="$t('visible-in-sidebar')" class="mb-0" />

                        <template v-if="workflow.visibleinsidebar" class="mt-3">
                            <TextInput :label="$t('sidebar-caption')" v-model="workflow.sidebarcaption"
                                :placeholder="workflow.title" />
                            <SelectInput :label="$t('homescreen-style')" v-model="workflow.homescreentype"
                                :options="homescreentypeOptions" />
                        </template>
                    </div>
                </div-->
            </div>

            <div class="col-12 col-lg-4 mb-4">
                <YearMultiSelect v-model="workflow.programme_years" class="list-group border-radius-2 no-border" />
            </div>

            <div class="col-12 col-lg-4">
                <RoleSelector v-model="workflow.select_roles" />
            </div>
        </div>

        <template v-if="workflow.id" class="mb-5">
            <h2 class="clearfix mb-3">
                {{ $t('stages') }}
                <router-link :to="`/settings/workflows/${workflow.id}/stages/`" class="btn btn-secondary float-right">{{
                    $t('new') }}</router-link>
            </h2>
            <div v-for="stage in workflow.stages" :key="stage.id" class="list-group no-border border-radius-2 mb-3">
                <WidgetHeader :link="`/settings/workflows/${workflow.id}/stages/${stage.id}`">{{ stage.title }}
                </WidgetHeader>
                <div v-if="stage.note" class="list-group-item">{{ stage.note }}</div>
            </div>
        </template>


        <!-- <div class="row mb-4">
			<div class="col-12" v-if="workflow.id">
				<LearningOutcomesMapper
					:learningoutcomes="workflow.learningoutcomes"
				/>
			</div>
		</div> -->
    </div>
</template>

<script>
import WidgetHeader from "src/components/widgets/WidgetHeader";
// import LearningOutcomesMapper from "src/components/LearningOutcomes/LearningOutcomesMapper";
import YearMultiSelect from "src/components/ProgrammeYearGroups/YearMultiSelect.vue";
import RoleSelector from "src/components/Roles/RoleSelector.vue";
import CheckboxInput from "../../../components/Inputs/CheckboxInput.vue";
import StatusSelector from "../../../components/StatusSelector.vue";

export default {
    components: {
        WidgetHeader,
        // LearningOutcomesMapper,
        YearMultiSelect,
        RoleSelector,
        CheckboxInput,
        StatusSelector
    },
    mounted() {
        if (this.$route.params.id) this.fetchWorkflow().then(() => this.loading = false)
    },
    data() {
        return {
            loading: !!this.$route.params.id,
            submitting: false,
            workflow: {
                id: null,
                title: '',
                note: '',
                visibleinnewmenu: false,
                newcaption: '',
                visibleinsidebar: false,
                sidebarcaption: '',
                homescreentype: null,
                programmes: [],
                programme_years: [],
                select_roles: [],
                stages: [],
                learningoutcomes: [],
                status: 1
            },
            homescreentypeOptions: {
                'dashboard': this.$t('dashboard'),
                'list': this.$t('list')
            },
            saved: false
        }
    },
    methods: {
        saveWorkflow() {
            if (this.submitting) return
            this.submitting = true

            this.saved = false
            this.$store.commit('showBlockingSpinner')

            return this.$cfetch(`${this.$settings.APIBaseURL}/workflows/save`, {
                method: 'POST',
                data: this.workflow,
            })
                .then(res => {
                    if (res.status !== 'SUCCESS') throw new Error('Unexpected error saving workflow')

                    if (!this.workflow.id) this.$router.replace(`/settings/workflows/edit/${res.result.id}`)
                    else this.saved = true
                })
                .catch(err => {
                    console.error(err)
                    this.$log.error.call(this, err);

                    this.$store.commit('openDialog', {
                        title: this.$t('something-went-wrong'),
                        content: this.$t('error-saving-workflow'),
                    })
                })
                .finally(() => {
                    this.$store.commit('hideBlockingSpinner')
                    this.submitting = false
                })
        },
        fetchWorkflow() {
            this.$store.commit('showBlockingSpinner')

            return this.$cfetch(`${this.$settings.APIBaseURL}/workflows/get`, {
                method: 'GET',
                data: { id: this.$route.params.id }
            })
                .then(res => {
                    if (res.status !== 'SUCCESS') throw new Error('Unexpected error fetching workflow')

                    this.workflow = res.result
                })
                .catch(error => {
                    this.$log.error.call(this, error)
                    this.$router.push('/settings/workflows')
                })
                .finally(() => {
                    this.$store.commit('hideBlockingSpinner')
                })
        },
       
    },
    watch: {
        'workflow.visibleinsidebar': function (newVal) {
            if (newVal && !this.workflow.sidebarcaption) this.workflow.sidebarcaption = this.workflow.title
        },
        'workflow.visibleinnewmenu': function (newVal) {
            if (newVal && !this.workflow.newcaption) this.workflow.newcaption = this.workflow.title
        }
    }
}
</script>
